import React from "react";
import { useAppContext } from "../../AppProvider.jsx";
import ButtonUtility from "../../Components/Buttons/Utility.tsx";
import ButtonConfirm from "../../Components/Buttons/Confirm.tsx";
import { useShipmentConfirmContext } from "./providers/hooks.ts";

const ShipmentConfirm = () => {
  const { callback, confirmShipments, loader } = useShipmentConfirmContext();
  const { dictionary } = useAppContext();

  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col text-center">
          <label>
            {dictionary.shipments.shipment_tracking_activated}{" "}
            {dictionary.messages.are_you_sure_you_want_to_continue}
          </label>
        </div>
      </div>
      <div className="d-flex">
        <ButtonUtility
          className="w-50 me-2"
          onClick={() => {
            if (callback) {
              callback();
            }
          }}
        >
          {dictionary.actions.cancel}
        </ButtonUtility>
        <ButtonConfirm
          className="w-50"
          onClick={() => confirmShipments()}
          disabled={loader}
          loading={loader}
        >
          {dictionary.actions.confirm}
        </ButtonConfirm>
      </div>
    </React.Fragment>
  );
};
export default ShipmentConfirm;
